export default function FAQuestionContentPar(props:any) {
    return <div className="mb-3">{props.children}</div>
}